import { assertUnreachable } from '@sfstudios/shapeshifter';
import { getEnvVariable } from '../getEnvVariable';
import { samsungUtils } from './samsungUtils';
import { DeviceUtils, deviceUtilsDefault, Platforms } from './types';
import { getApproximateWebosVersion } from './webosUtils';

interface IPlatform {
  OS: Platforms | null;
  samsung(): boolean;
  philips(): boolean;
  lg(): boolean;
  vewd(): boolean;
  isLowEnd(): boolean;
  isModern(): boolean;
  isDiscontinued(): boolean;
  supportsScroll(): boolean;
  supportsMouse(): boolean;
  version(): string;
}

let currentPlatform: Platforms | null = null;

const platformFromEnv = getEnvVariable(
  'REACT_APP_PLATFORM',
  'unknown-tv'
) as Platforms;

let deviceUtils: DeviceUtils = deviceUtilsDefault;

switch (platformFromEnv) {
  case 'philips':
    currentPlatform = platformFromEnv;
    break;
  case 'samsung':
    deviceUtils = samsungUtils;
    currentPlatform = platformFromEnv;
    break;
  case 'vewd':
    currentPlatform = platformFromEnv;
    break;
  case 'lg':
    currentPlatform = platformFromEnv;
    break;
  case 'UNKNOWN':
    break;
  default: {
    assertUnreachable(platformFromEnv);
  }
}

export const Platform: IPlatform = {
  OS: currentPlatform,

  samsung: () => currentPlatform === 'samsung',
  lg: () => currentPlatform === 'lg',
  vewd: () => currentPlatform === 'vewd',
  philips: () => currentPlatform === 'philips',
  isLowEnd: () => {
    switch (currentPlatform) {
      case 'lg': {
        const webosVersion = getApproximateWebosVersion();
        if (webosVersion !== null && webosVersion < 4) {
          return true;
        }
        break;
      }
      case 'samsung': {
        return deviceUtils.isLowEnd;
      }
    }

    return false;
  },
  isModern: () => {
    switch (currentPlatform) {
      case 'lg': {
        const webosVersion = getApproximateWebosVersion();
        if (webosVersion !== null && webosVersion >= 22) {
          return true;
        }
        break;
      }
      case 'samsung': {
        return deviceUtils.isModern;
      }
    }
    return false;
  },
  isDiscontinued: () => deviceUtils.isDiscontinued,
  supportsMouse: () => currentPlatform === 'lg' || currentPlatform === 'vewd',
  supportsScroll: () => currentPlatform === 'lg' || currentPlatform === 'vewd',
  version: () => deviceUtils.version.semver.version
};
